import React from 'react';
import { ImageUpload, UploadInfo } from '../../libs/gs-component-image-upload';
import { Body1 } from '@xo-union/tk-ui-typography';
import styles from './coverPhoto.scss';
import verticalLayout from './layoutVertical.svg';
import horizontalLayout from './layoutHorizontal.svg';
import useResizeObserver from 'use-resize-observer';
import { HORIZONTAL_ICON, VERTICAL_ICON } from '../Modals/PhotoCropper/LayoutToggle';

interface Props {
  onAddCoverPhotoClick: (uploadInfo: UploadInfo) => Promise<void>;
  onOpenCropperWithLayout: (uploadInfo: UploadInfo, ratioLayout: string) => Promise<void>;
}

const ZeroState: React.FC<Props> = ({ onAddCoverPhotoClick, onOpenCropperWithLayout }) => {
  const { ref, width = 1 } = useResizeObserver<HTMLDivElement>();

  const uploadPhotoClick = (uploadInfo: UploadInfo, layoutClicked: string) => {
    if (onOpenCropperWithLayout && layoutClicked) {
      const layout = layoutClicked === 'vertical' ? VERTICAL_ICON : HORIZONTAL_ICON;
      onOpenCropperWithLayout(uploadInfo, layout);
    } else if (onAddCoverPhotoClick) {
      onAddCoverPhotoClick(uploadInfo);
    }
  };

  return (
    <div ref={ref} className={width < 709 ? 'zeroStateSmallContainer' : ''}>
      <div className={styles.zeroStateContainer}>
        <Body1 className={styles.zeroStateCopy}>Choose a cover photo layout:</Body1>
        <div className={styles.zeroStateCardContainer} data-testid="empty-cover-photo">
          <div className={styles.zeroStateCardWrapper}>
            <ImageUpload onUploadEnded={info => uploadPhotoClick(info, 'horizontal')}>
              <div className={styles.zeroStateCard}>
                <img src={horizontalLayout} alt="Horizontal Layout" />
                <div className={styles.zeroStateCardCopy}>
                  <Body1 className={styles.zeroStateHeader}>Horizontal</Body1>
                  <Body1 className={styles.zeroStateSubLink}>Add a wide photo</Body1>
                </div>
              </div>
            </ImageUpload>
          </div>
          <div className={styles.zeroStateCardWrapper}>
            <ImageUpload onUploadEnded={info => uploadPhotoClick(info, 'vertical')}>
              <div className={styles.zeroStateCard}>
                <img src={verticalLayout} alt="Vertical Layout" />
                <div className={styles.zeroStateCardCopy}>
                  <Body1 className={styles.zeroStateHeader}>Vertical</Body1>
                  <Body1 className={styles.zeroStateSubLink}>Add a tall photo</Body1>
                </div>
              </div>
            </ImageUpload>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZeroState;
